angular.module('uib/template/typeahead/typeahead-popup.html', []).run(['$templateCache', function ($templateCache) {
  $templateCache.put('uib/template/typeahead/typeahead-popup.html',
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    '<div>\n' +
    '<li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n' +
'        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n' +
'    </li>\n' +
    '</div>\n' +
'</ul>\n' +
'')
}])
